"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWSSecretsManagerClient = void 0;
const client_secrets_manager_1 = require("@aws-sdk/client-secrets-manager");
class AWSSecretsManagerClient {
    constructor() {
        this.client = new client_secrets_manager_1.SecretsManagerClient();
    }
    fetchSecretValue(secretArn) {
        const command = new client_secrets_manager_1.GetSecretValueCommand({
            SecretId: secretArn,
        });
        return this.client.send(command);
    }
}
exports.AWSSecretsManagerClient = AWSSecretsManagerClient;
//# sourceMappingURL=AWSSecretsManagerClient.js.map